/* Product form: add to cart via AJAX, update the cart count and confirm with a toast.
   Rewritten Oct 2026 (Refresh). The old version referenced cart-drawer elements that no
   longer exist in the header, so it threw an error after every add and gave no feedback. */
(function () {
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  function updateCartCount(count) {
    if (count === null || count === undefined) return;
    document.querySelectorAll('.cart-count-badge, #cart-details--sticky, #cart-details--relative').forEach(function (el) {
      el.textContent = count;
    });
  }

  function fetchCount() {
    return fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count; })
      .catch(function () { return null; });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  var toastTimer;
  function showToast(item, count) {
    var toast = document.getElementById('RfCartToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'RfCartToast';
      toast.className = 'rf-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
      toast.addEventListener('click', function (e) {
        if (e.target.closest('[data-rf-toast-close]')) hideToast();
      });
    }
    var img = item && (item.featured_image && item.featured_image.url || item.image);
    var title = item && (item.product_title || item.title) || 'Item';
    var variant = item && item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var plan = item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.name : '';
    toast.innerHTML =
      '<button type="button" class="rf-cart-toast__close" data-rf-toast-close aria-label="Close">&times;</button>' +
      '<p class="rf-cart-toast__label">✓ Added to your cart</p>' +
      '<div class="rf-cart-toast__item">' +
        (img ? '<img src="' + esc(img) + (String(img).indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="">' : '') +
        '<div><strong>' + esc(title) + '</strong>' +
        (variant ? '<span>' + esc(variant) + '</span>' : '') +
        (plan ? '<span>' + esc(plan) + '</span>' : '') +
        '</div>' +
      '</div>' +
      '<div class="rf-cart-toast__actions">' +
        '<button type="button" class="rf-cart-toast__btn rf-cart-toast__btn--ghost" data-rf-toast-close>Keep shopping</button>' +
        '<a class="rf-cart-toast__btn" href="' + cartUrl() + '">View cart' + (count ? ' (' + count + ')' : '') + ' &amp; checkout</a>' +
      '</div>';
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 7000);
  }
  function hideToast() {
    var t = document.getElementById('RfCartToast');
    if (t) t.classList.remove('is-visible');
  }
  window.rfShowCartToast = showToast;

  if (customElements.get('product-form')) return;

  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;
      var idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      var formData = new FormData(this.form);
      formData.append('sections', 'cart-bubble');
      var self = this;

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            self.handleErrorMessage(response.description || response.message || 'Sorry, this item could not be added.');
            self.error = true;
            return;
          }
          var count = null;
          try {
            var m = String((response.sections && response.sections['cart-bubble']) || '').match(/\d+/);
            if (m) count = m[0];
          } catch (e) {}
          var done = function (c) {
            updateCartCount(c);
            showToast(response, c);
          };
          if (count === null) { fetchCount().then(done); } else { done(count); }
          self.error = false;
        })
        .catch(function (error) {
          console.error(error);
          self.handleErrorMessage('Something went wrong. Please try again.');
        })
        .finally(function () {
          self.submitButton.classList.remove('loading');
          self.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorText) {
      if (this.hideErrors) return;
      this.errorMessage = this.errorMessage || this.querySelector('.message-error');
      if (!this.errorMessage) return;
      var svg = this.errorMessage.querySelector('svg');
      var icon = svg ? svg.outerHTML : '';
      if (errorText) {
        this.errorMessage.hidden = false;
        this.errorMessage.classList.remove('hidden');
        this.errorMessage.innerHTML = icon + '<span>' + esc(errorText) + '</span>';
      } else {
        this.errorMessage.hidden = true;
        this.errorMessage.classList.add('hidden');
        this.errorMessage.innerHTML = icon;
      }
    }
  });
})();
